import { render, staticRenderFns } from "./doctorAdvice.vue?vue&type=template&id=b2e18b8e&scoped=true&"
import script from "./doctorAdvice.vue?vue&type=script&lang=js&"
export * from "./doctorAdvice.vue?vue&type=script&lang=js&"
import style0 from "./doctorAdvice.vue?vue&type=style&index=0&id=b2e18b8e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e18b8e",
  null
  
)

component.options.__file = "doctorAdvice.vue"
export default component.exports